import hres7feLabels from 'assets/labels/hres7fe'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres7feLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codcours: faker.lorem.word(),
        dteyear: moment().format('YYYY'),
        desc_codcours: faker.name.findName(),
        numclseq: faker.random.number().toString().substr(0, 1),
        codtparg: faker.lorem.word(),
        desc_codtparg: faker.lorem.word(),
        flgappr: '',
        desc_flgappr: faker.lorem.word(),
        codappr: '',
        codempid: '',
        dteapman: moment().format('DD/MM/YYYY')
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTrainingby = []
    const mockTrainingbyTotal = 4
    const mockCheck = [true, false]
    for (var d = 1; d <= mockTrainingbyTotal; d++) {
      mockTrainingby.push({
        name: faker.lorem.word(),
        value: faker.lorem.word().substr(0, 2),
        check: mockCheck[Math.floor(Math.random() * 2)]
      })
    }
    let mockInformtby = []
    const mockInformtbyTotal = 6
    for (d = 1; d <= mockInformtbyTotal; d++) {
      mockInformtby.push({
        name: faker.lorem.word(),
        value: faker.lorem.word().substr(0, 2),
        check: mockCheck[Math.floor(Math.random() * 2)]
      })
    }
    let mockTab1 = {
      qtyprescr: faker.random.number().toString().substr(0, 1),
      qtypostscr: faker.random.number().toString().substr(0, 1),
      trainingby: mockTrainingby,
      informtby: mockInformtby,
      flgappr: '',
      desc_flgappr: faker.lorem.word()
    }
    let mockTab1Table2Rows = []
    const mockChoice = [ 'A', 'B', 'C', 'D' ]
    const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
    const mockScore = [ '4', '3', '2', '1' ]
    const mockTab1Table2Total = 4
    for (d = 1; d <= mockTab1Table2Total; d++) {
      mockTab1Table2Rows.push({
        grditem: d,
        grad: mockChoice[d - 1],
        qtyscor: mockScore[d - 1],
        desc_grditem: mockDescChoice[d - 1],
        definit: ''
      })
    }
    let mockTab1Table1GroupRows = []
    const mockTab1Table1Total = 3
    for (var a = 1; a <= mockTab1Table1Total; a++) {
      let mockTab1Table1ItemRows = []
      const mockTab1Table1ItemTotal = 3
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var e = 1; e <= mockTab1Table1ItemTotal; e++) {
        let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGrditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGrditem * mockItemQtywgt
        let mockChoiceFiltered = mockTab1Table2Rows.filter((choice) => {
          return choice.grditem === mockItemGrditem
        })
        let mockGrad = ''
        if (mockChoiceFiltered.length > 0) {
          mockGrad = mockChoiceFiltered[0].grad
        }
        mockTab1Table1ItemRows.push({
          numitem: e,
          desc_numitem: 'description ',
          definit: 'Sub description',
          qtyfscor: mockItemQtyfscor,
          qtyscor: mockItemQtyscor,
          grditem: mockItemGrditem,
          grad: mockGrad,
          qtywgt: mockItemQtywgt
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockTab1Table1GroupRows.push({
        numgrup: a,
        desgrup: 'หัวข้อเรื่อง',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        numitem: mockTab1Table1ItemRows
      })
    }
    let mockTab2 = {
      dessummary: faker.lorem.word(),
      desbenefit: faker.lorem.word(),
      descomment: faker.lorem.word()
    }

    return {
      tab1: {
        detail: mockTab1,
        table1: {
          total: mockTab1Table1Total,
          rows: mockTab1Table1GroupRows
        },
        table2: {
          total: mockTab1Table2Total,
          rows: mockTab1Table2Rows
        }
      },
      tab2: mockTab2
    }
  },
  indexCancel () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres7fe/mocker.js